<script setup>
import { onMounted, onUnmounted } from 'vue'
import Lenis from '@studio-freight/lenis'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

let lenis

onMounted(() => {
  lenis = new Lenis({
    lerp: 0.1,
    // wheelMultiplier: 0.5,
    touchMultiplier: 0.5,
    touchInertiaMultiplier: 0.5,
    // smoothWheel: true,
    smoothTouch: true,
  })

  // Utilisez soit ceci:
  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
  }
  requestAnimationFrame(raf)

  // Ou cela, mais pas les deux:
  // gsap.ticker.add(time => {
  //   lenis.raf(time * 1000)
  // })
  // gsap.ticker.lagSmoothing(0)
  lenis.on('scroll', e => {
    ScrollTrigger.update(e)
    document.dispatchEvent(
      new CustomEvent('lenis_scroll', {
        detail: e,
      }),
    )
  })

  window.blockScroll = lenis.stop
  window.allowScroll = lenis.start
})

onUnmounted(() => {
  if (lenis) {
    lenis.off('scroll', ScrollTrigger.update)
    lenis.destroy()
  }
  ScrollTrigger.getAll().forEach(trigger => trigger.kill())
})
</script>

<template>
  <slot />
</template>
